import { Route } from "react-router-dom";

import { withSentryReactRouterV6Routing } from "@sentry/react";

export const SentryRoute = withSentryReactRouterV6Routing(Route);
